import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import CoachDashboard from "@/pages/CoachDashboard";
import StudentDashboard from "@/pages/StudentDashboard";

const ProtectedRoute = ({ children, allowedRole }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-pulse text-primary font-heading text-2xl">
          Caricamento...
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRole && user.role !== allowedRole) {
    return <Navigate to={user.role === "coach" ? "/coach" : "/student"} replace />;
  }

  return children;
};

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to={user.role === "coach" ? "/coach" : "/student"} replace /> : <LandingPage />} />
      <Route path="/login" element={user ? <Navigate to={user.role === "coach" ? "/coach" : "/student"} replace /> : <LoginPage />} />
      <Route path="/register" element={user ? <Navigate to={user.role === "coach" ? "/coach" : "/student"} replace /> : <RegisterPage />} />
      <Route path="/forgot-password" element={user ? <Navigate to={user.role === "coach" ? "/coach" : "/student"} replace /> : <ForgotPasswordPage />} />
      <Route
        path="/coach/*"
        element={
          <ProtectedRoute allowedRole="coach">
            <CoachDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/student/*"
        element={
          <ProtectedRoute allowedRole="student">
            <StudentDashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
